import { DatePicker, Input, Select, notification } from 'antd';
import React, { useEffect, useState } from 'react';
import FormWrapper from './FormWrapper';
import FormActionButton from '../../ui/FormActionButton';
import Title from '../../ui/Title';
import { useNavigate, useSearchParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { fetchtEnterpriseSubscriptionList } from '../../../store/slices/enterprise-subscription-slice';
import { fetchSubscriptionPlanList } from '../../../store/slices/subscription-plan-slice';
import { fetchCustomers } from '../../../store/slices/customer-slice';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const USER_NAME = process.env.REACT_APP_USER_NAME;
const PASSWORD = process.env.REACT_APP_PASSWORD;

const EnterpriseSubscriptionForm = () => {
    const [subscriptionPlanId, setSubscriptionPlanId] = useState('');
    const [customerId, setCustomerId] = useState('');
    const [amount, setAmount] = useState('');
    const [balanceAmount, setBalanceAmount] = useState('');
    const [paymentStatus, setPaymentStatus] = useState('');
    const [date, setDate] = useState({
        dateValue: '',
        dateString: '',
    });

    const [api, contextHolder] = notification.useNotification();

    const [searchParams] = useSearchParams();
    const MODE = searchParams.get('mode');
    const navigate = useNavigate();
    const { data: enterpriseSubscriptionList } = useSelector((state) => state.enterpriseSubscription);
    const { data: subscriptionPlans } = useSelector((state) => state.subscriptionPlan);
    const { data: customers } = useSelector((state) => state.customer);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchtEnterpriseSubscriptionList());
        dispatch(fetchSubscriptionPlanList());
        dispatch(fetchCustomers());
    }, []);

    useEffect(() => {
        console.log(MODE);
        if(MODE === 'EDIT' && enterpriseSubscriptionList.length) {
            const ID = searchParams.get('id');
            const selectedentErpriseSubscription = enterpriseSubscriptionList.filter((item) => item.subscription_id === ID);
            setSubscriptionPlanId(selectedentErpriseSubscription[0].subscription_plan_id);
            setCustomerId(selectedentErpriseSubscription[0].customer_id);
            setAmount(selectedentErpriseSubscription[0].amount);
            setBalanceAmount(selectedentErpriseSubscription[0].balance_amount);
            setPaymentStatus(selectedentErpriseSubscription[0].payment_status);
            setDate({ 
                dateValue: dayjs(selectedentErpriseSubscription[0].date.split(' ')[0]), 
                dateString: selectedentErpriseSubscription[0].date.split(' ')[0] 
            });
        }
        if(MODE === 'ADD') {
            resetHandler();
        }
    }, [MODE, enterpriseSubscriptionList]);

    const subscriptionPlanList = subscriptionPlans.map((item) => (
        { value: item.subscription_plan_id, label: item.subscription_plan_name }
    ));
    const customerList = customers.map((customer) => (
        { value: customer.customer_id, label: customer.customer_name }
    ));

    const openNotification = ({type, message, description}) => {
        api[type]({
            message,
            description,
            placement: 'bottomRight',
        });
    }

    const submitHandler = async (e) => {
        e.preventDefault();
        const details = {
            'subscription_plan_id': subscriptionPlanId,
            'date': date.dateString,
            'customer_id': customerId,
            'amount': amount,
            'balance_amount': balanceAmount,
            'payment_status': paymentStatus,
        };
        if(MODE === 'EDIT') {
            const ID = searchParams.get('id');
            details.subscription_id = ID;
        }

        var formBody = [];
        for (var property in details) {
        var encodedKey = encodeURIComponent(property);
        var encodedValue = encodeURIComponent(details[property]);
        formBody.push(encodedKey + "=" + encodedValue);
        }
        formBody = formBody.join("&");

        try {
            const response = await fetch(`${API_BASE_URL}/enterprise-subscription/${MODE === 'ADD' ? 'add' : 'edit'}`, {
                method: 'POST',
                headers: { 
                    'Authorization': 'Basic ' + btoa(`${USER_NAME}:${PASSWORD}`),
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: formBody
            });
            const responseData = await response.json();

            if(responseData.code === 200) {
                openNotification(
                    { 
                        type: 'success',
                        message: 'Successfully Submitted!', 
                        description: responseData.message,
                    }
                );
                resetHandler();
                if(MODE === 'EDIT') {
                    setTimeout(() => {
                        navigate('/dashboard/enterprise-subscription-list');
                    }, 1500);
                }
            } else {
                openNotification(
                    { 
                        type: 'error',
                        message: 'Failed to Submit!', 
                        description: responseData.message,
                    }
                );
            }
        } catch (error) {
            openNotification(
                    { 
                        type: 'error',
                        message: 'Failed to Submit!', 
                        // description: error,
                    }
                );
        }
        
        
    }
    const resetHandler = () => {
        setSubscriptionPlanId('');
        setDate('');
        setCustomerId('');
        setAmount('');
        setBalanceAmount('');
        setPaymentStatus('');
    }
    return (
        <FormWrapper>
            {contextHolder}
            <Title>{MODE} Enterprise Subscription</Title>
            <form onSubmit={submitHandler}>
                <div className='control'>
                    <label>Subscription Plan:</label>
                    <Select
                        placeholder="Select Subscription Plan"
                        style={{ width: '100%' }}
                        size='large'
                        onChange={(value) => setSubscriptionPlanId(value)}
                        options={subscriptionPlanList}
                        allowClear
                        {...(subscriptionPlanId && { value: subscriptionPlanId })}
                    />
                </div>
                <div className='control'>
                    <label>Date:</label>
                    <div style={{width: '100%'}}>
                        <DatePicker 
                            onChange={(date, dateString) => setDate({ dateValue: date, dateString: dateString })} 
                            value={date.dateValue}
                            size='large' 
                            style={{width: '100%', borderRadius: '0.2rem'}} 
                        />
                    </div>
                </div>
                <div className='control'>
                    <label>Customer:</label>
                    <Select
                        placeholder="Customer"
                        style={{ width: '100%' }}
                        size='large'
                        onChange={(value) => setCustomerId(value)}
                        options={customerList}
                        allowClear
                        {...(customerId && { value: customerId })}
                    />
                </div>
                <div className='control'>
                    <label>Amount:</label>
                    <Input 
                        onChange={(e) => setAmount(e.target.value)} 
                        value={amount}
                        size='large' 
                        placeholder='Amount' 
                    />
                </div>
                <div className='control'>
                    <label>Balance Amount:</label>
                    <Input
                        onChange={(e) => setBalanceAmount(e.target.value)} 
                        value={balanceAmount} 
                        size='large' 
                        placeholder='Balance Amount' 
                    />
                </div>
                <div className='control'>
                    <label>Payment Status:</label>
                    <Input 
                        onChange={(e) => setPaymentStatus(e.target.value)} 
                        value={paymentStatus}
                        size='large' 
                        placeholder='Payment Status' 
                    />
                </div>
                <div className='control'>
                    <FormActionButton bg='#ff6b6b' onClick={resetHandler} type='button'>
                        Reset 
                    </FormActionButton>
                    <FormActionButton type='submit' bg='#10ac84'>
                        Submit 
                    </FormActionButton>
                </div>
            </form>
        </FormWrapper>
    );
}

export default EnterpriseSubscriptionForm;


